'use strict';

const errorNotice = (function(){
    function showErrorBar(msg, level = 'error') {
        const alertBar = document.createElement('p');
        alertBar.innerHTML = msg;
        alertBar.classList.add('site-notice','site-notice--'+level);
        document.body.insertBefore(alertBar, document.body.firstChild);
    }

    function showDataError(errorMsg = 'Ongelma THL rajapinnassa, dataa ei saatavilla.', elemsClass, errorBar = true) {
        if (errorBar) {
            showErrorBar(errorMsg);
        }

        const dataElems = document.querySelectorAll(elemsClass);
        dataElems.forEach((elem) => {
            elem.innerHTML = '<p>'+errorMsg+'</p>';
        });
    }

    return {
        showDataError
    }
})();

export default errorNotice;
